import httpClient from "@/services";
import type { IUserInfo } from "@/hooks/use-user-info";
import type { Feature } from "@/model/features";

// v1 — returns flat Feature[] filtered server-side to the active plan.
// Kept for reference. Replaced by featuresV2 which returns plan-keyed data.
// export const features = async (userInfo: IUserInfo): Promise<Feature[]> => {
//   const payloadData = {
//     loginGroupId: userInfo.loginGroupId,
//     memberId: userInfo.memberId,
//     groupId: userInfo.groupId,
//     divisionId: userInfo.divisionId,
//     planId: userInfo.planId,
//   };
//
//   const config = {
//     method: "POST",
//     url: "home/featureList",
//     headers: {
//       "Content-Type": "application/json",
//       "Accept-Version": "2.0",
//       Authorization: `Bearer ${userInfo.accessToken}`,
//     },
//     data: payloadData,
//   };
//
//   return httpClient.request(config).then((response) => {
//     if (response.data.error) {
//       throw new Error(response.data.message);
//     }
//     return response.data.data;
//   });
// };

export interface FeatureListResponse {
  summary: {
    status_message: string;
    member_id: string;
    status_code: string;
    [key: string]: unknown;
  };
  data: Record<string, Feature[]>; // { MED: [...], DEN: [...], VIS: [...] }
}

// v2 — returns plan-keyed map so the frontend owns plan switching.
// Accept-Version: 3.0 — backend must return { data: { MED:[...], DEN:[...] } }
export const features = async (
  userInfo: IUserInfo,
): Promise<FeatureListResponse> => {
  const payloadData = {
    loginGroupId: userInfo.loginGroupId,
    memberId: userInfo.memberId,
    groupId: userInfo.groupId,
    divisionId: userInfo.divisionId,
    planId: userInfo.planId,
  };

  const config = {
    method: "POST",
    url: "home/featureList",
    headers: {
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
      Authorization: `Bearer ${userInfo.accessToken}`,
    },
    data: payloadData,
  };

  return httpClient.request(config).then((response) => {
    if (response.data.error) {
      throw new Error(response.data.message);
    }
    return response.data as FeatureListResponse;
  });
};
